import type { Country } from '@seek/audience-zones';
import type { Brand, Locale } from '@seek/ca-myprofile-utils';
import { siteNames } from '@seek/melways-sites';

import type { Site } from './types';

export const siteNameToCountryMap: Record<Site, Country> = {
  [siteNames.candidate.seek.au]: 'AU',
  [siteNames.candidate.seek.nz]: 'NZ',
  [siteNames.candidate.jobsdb.hk]: 'HK',
  [siteNames.candidate.jobsdb.th]: 'TH',
  [siteNames.candidate.jobstreet.my]: 'MY',
  [siteNames.candidate.jobstreet.sg]: 'SG',
  [siteNames.candidate.jobstreet.ph]: 'PH',
  [siteNames.candidate.jobstreet.id]: 'ID',
};

export const siteNameToLocaleMap: Record<Site, Locale> = {
  [siteNames.candidate.seek.au]: 'AU',
  [siteNames.candidate.seek.nz]: 'NZ',
  [siteNames.candidate.jobsdb.hk]: 'HK',
  [siteNames.candidate.jobsdb.th]: 'TH',
  [siteNames.candidate.jobstreet.my]: 'MY',
  [siteNames.candidate.jobstreet.sg]: 'SG',
  [siteNames.candidate.jobstreet.ph]: 'PH',
  [siteNames.candidate.jobstreet.id]: 'ID',
};

export const siteNameToBrandMap: Record<Site, Brand> = {
  [siteNames.candidate.seek.au]: 'SEEK',
  [siteNames.candidate.seek.nz]: 'SEEK',
  [siteNames.candidate.jobsdb.hk]: 'Jobsdb',
  [siteNames.candidate.jobsdb.th]: 'Jobsdb',
  [siteNames.candidate.jobstreet.my]: 'Jobstreet',
  [siteNames.candidate.jobstreet.sg]: 'Jobstreet',
  [siteNames.candidate.jobstreet.ph]: 'Jobstreet',
  [siteNames.candidate.jobstreet.id]: 'Jobstreet',
};
